import { render, staticRenderFns } from "./NameChangeApplicationConfirmationPopup.vue?vue&type=template&id=03a8c56e&scoped=true&"
import script from "./NameChangeApplicationConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./NameChangeApplicationConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./NameChangeApplicationConfirmationPopup.vue?vue&type=style&index=0&id=03a8c56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8c56e",
  null
  
)

export default component.exports